export default __webpack_public_path__ + "static/setka-98a6ab441219951f73d82b43dbfdfc44.svg";